import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import { App } from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// Admin tool pages — rendered without the main app shell.
// Protected by ADMIN_SECRET bearer token on the API side.
const ADMIN_ROUTES: Record<string, () => Promise<{ default: React.ComponentType }>> = {
  '/admin/api-costs-manual-entry': () => import('./pages/admin/api-costs-manual-entry'),
};

const adminLoader = ADMIN_ROUTES[window.location.pathname];

if (adminLoader) {
  adminLoader().then(({ default: AdminPage }) => {
    createRoot(root).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <div className="min-h-screen bg-brand-paper">
            <AdminPage />
          </div>
        </QueryClientProvider>
      </StrictMode>,
    );
  }).catch((err: unknown) => {
    root.textContent = `Failed to load admin page: ${String(err)}`;
  });
} else {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
}

